import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { cn } from '../../../../utils/styles';

export const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex h-[23px] w-[42px] shrink-0 cursor-pointer items-center rounded-full border ' +
        'shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ' +
        'focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed ' +
        'disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-white',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn([
        'pointer-events-none block h-[19px] w-[19px] rounded-full bg-background shadow-lg ring-0 ',
        'data-[state=checked]:translate-x-[19px] data-[state=unchecked]:translate-x-[2px]',
        'data-[state=unchecked]:bg-primary',
        'transition-transform opacity-20 data-[state=checked]:bg-white data-[state=checked]:opacity-100',
      ])}
    />
  </SwitchPrimitives.Root>
));

Switch.displayName = SwitchPrimitives.Root.displayName;

export default { Switch };
